import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "header-menu align-items-stretch",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "header-menu",
  "data-kt-drawer-activate": "{default: true, lg: false}",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_header_menu_mobile_toggle",
  "data-kt-place": "true",
  "data-kt-place-mode": "prepend",
  "data-kt-place-parent": "{default: '#kt_body', lg: '#kt_header_nav'}"
}
const _hoisted_2 = {
  class: "menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch",
  id: "#kt_header_menu",
  "data-kt-menu": "true"
}
const _hoisted_3 = { class: "menu-item me-lg-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle fs-4 me-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Review 4 phương")
const _hoisted_6 = { class: "menu-item me-lg-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle fs-4 me-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Dự án")
const _hoisted_9 = { class: "menu-item me-lg-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle fs-4 me-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Tin tức")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: { name: 'experiences-add' },
          class: "btn btn-sm btn-primary me-2"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: { name: 'projects-add' },
          class: "btn btn-sm btn-primary me-2"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: { name: 'news-add' },
          class: "btn btn-sm btn-primary me-2"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        })
      ])
    ])
  ]))
}